import { botModeStatus } from '../tenant-sections/BotModeSection';
import { erpStatus } from '../tenant-sections/ErpSection';
import { identityStatus } from '../tenant-sections/IdentitySection';
import type { SectionNavItem } from '../tenant-sections/SectionNav';
import { telegramStatus } from '../tenant-sections/TelegramSection';
import { whatsappStatus } from '../tenant-sections/WhatsAppSection';
import type { SectionStatus } from '../tenant-sections/types';
import type { WizardDraft, WizardStep } from './types';

const LABELS: Record<WizardStep, string> = {
  1: 'Identidad',
  2: 'Telegram',
  3: 'WhatsApp',
  4: 'Integración',
  5: 'Modo del bot',
  6: 'Resumen',
};

/**
 * Estado de cada paso derivado del draft — es lo que pinta el punto de color
 * del stepper. No consulta la API: el draft ya refleja lo que se guardó.
 */
export function wizardStepStatus(draft: WizardDraft, step: WizardStep): SectionStatus {
  switch (step) {
    case 1:
      return identityStatus({ tenantId: draft?.tenantId, name: draft?.name });
    case 2:
      return telegramStatus(draft?.channels?.telegram);
    case 3:
      return whatsappStatus(draft?.channels?.whatsapp);
    case 4:
      return erpStatus(draft?.erp as { type?: string; config?: Record<string, string> });
    case 5:
      return botModeStatus(draft?.botMode);
    default:
      return draft?.tenantId && draft?.erp && draft?.botMode ? 'partial' : 'empty';
  }
}

export function wizardNavItems(draft: WizardDraft): SectionNavItem[] {
  const steps: WizardStep[] = [1, 2, 3, 4, 5, 6];
  return steps.map((step) => ({
    id: String(step),
    label: LABELS[step],
    status: wizardStepStatus(draft, step),
    // Sin tenant creado no hay nada que configurar todavía.
    disabled: step > 1 && !draft?.tenantId,
  }));
}
